/* tslint:disable */
/* eslint-disable */
export enum RenderEngine {
    $10 = '1.0',
    $20 = '2.0'
}
